import React from 'react';
type CardProps = {
  children: React.ReactNode;
  title?: string;
  className?: string;
};
export const Card: React.FC<CardProps> = ({
  children,
  title,
  className = ''
}) => {
  return <div className={`bg-[#0A1128] border border-[#3A506B] rounded-lg p-4 ${className}`} data-id="element-891">
      {title && <h3 className="text-lg font-semibold mb-4" data-id="element-892">{title}</h3>}
      {children}
    </div>;
};